import { Grid } from '@material-ui/core';
import React, { FunctionComponent, useMemo } from 'react';
import HashtagCompare from '../HashtagCompare';
import HashtagSingle from '../HashtagSingle';
import InfluencerSingle from '../InfluencerSingle';
import VideoCompare from '../VideoCompare';
import VideoSingle from '../VideoSingle';

import styles from './AddComments.module.scss';

interface Props {
  moduleName: string;
  isCompare: boolean;
  items:Record<string,any>[];
}
const AddComments: FunctionComponent<Props> = ({ moduleName, isCompare,items }) => {
  const modules: any = {
    hashtags: isCompare ? <HashtagCompare items={items} /> : <HashtagSingle items={items} />,
    videos: isCompare ? <VideoCompare /> : <VideoSingle />,
    influencers: (
      <InfluencerSingle
        isReport
        items={items}
        isInfluencer={moduleName?.toLocaleLowerCase() === 'influencers'}
      />
    ),
    entities: <InfluencerSingle items={items} isEntity={moduleName?.toLocaleLowerCase() === 'entities'} isReport />,
  };
  const renderComp = useMemo(
    () => modules[moduleName?.toLocaleLowerCase()],

    [moduleName]
  );

  return (
    <Grid container spacing={4} className={styles.AddComments}>
      {renderComp}
    </Grid>
  );
};

export default AddComments;
